import {
  ActionType,
  AutoTextField,
  FormField,
  RadioGroupField,
  SelectAutocompleteField,
  SelectField,
} from '../../../components/AutoForm/AutoFieldNew';
// fullField duplicated from withdrawalFields for transfer domain use
import {moneyFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import {
  DAFeeFieldType,
  initialFeesFieldType,
  MomentDate,
} from '../CreateRecommend/recommendFields';
import {planFeesFieldType} from '../CreateRecommend/PlanFees';
import {newPlanFields} from '../RecommendsSetUpNew/setUpNewFields';
import {modelPortfolioField} from '../RecommendModify/modifyFieldTypes';

export type transferExistingSubplanFields = {
  planProvider?: string | null;
  singleClientAmount: moneyFieldValueType;
  parentId?: string;
  existingPotId: string | null;
  checked: boolean;
};

export type transferNewSubplanFields = {
  planProvider?: string | null;
  singleClientAmount: moneyFieldValueType;
  parentId?: string;
  existingPotId: string | null;
  checked: boolean;
  planFees?: planFeesFieldType;
  model?: modelPortfolioField;
  productProviderId?: string;
};

export type transferSourceType = {
  id: string;
  planFees: planFeesFieldType;
  initialFee: initialFeesFieldType;
  legacyInitialFee: DAFeeFieldType | null;
  checked: boolean;
  // reason?: string;
  full: boolean;
  inSpecie?: boolean;
  maxAmount: number;
  planValue?: number;
  singleClientAmount: moneyFieldValueType;
  // shell plan only fields
  planProvider?: string | null;
  planType?: string | null;
  accountNumber?: string | null;
  isShellPlan: boolean;
  originalOvrId?: string | null;
  originalShellPlanId?: string;
  isDataGather: 'yes' | 'no' | '';
  isAuthorityHeld: 'yes' | 'no' | '';
  contactId: string;
};

export type transferDestinationValuesType = {
  planProvider?: string | null;
  singleClientAmount: moneyFieldValueType;
  subplans?: Record<string, transferExistingSubplanFields>;
  isSaltusProvider?: boolean;
};

export type transferFieldsType = {
  transferSources: Record<string, transferSourceType>;
  destinationAccount?: string;
  destinationValues: transferDestinationValuesType;
  planProvider?: string | null;
  isTransferOut?: boolean;
  reason?: string;
  isPensionSharing: boolean;
  isDependantsPension: boolean;
  isAps: boolean;

  // New plan
  newPlan?: newPlanFields;

  // SUBPLAN / COMBINED AMOUNT FIELDS (duplicated from contribute)
  combinedOneOffMovingAmount?: number;
  combinedClientOneOffMovingAmount?: number;
};

export const transferAmountField: Omit<AutoTextField, 'id' | 'label'> = {
  type: ActionType.text,
  currency: true,
  decimals: 2,
  placeholder: '0',
  initialValue: '',
  allowZero: true,
  canBeEmpty: true,
};

export const transferFullField: RadioGroupField = {
  id: 'full',
  label: 'Full redemption?',
  type: ActionType.radioGroup,
  initialValue: false,
  horizontal: true,
  fullWidth: true,
  horizontalOptionWidthXs: 6,
  options: [
    {label: 'Full', value: true},
    {label: 'Partial', value: false},
  ],
};

export const transferInSpecieSourceField: RadioGroupField = {
  id: 'USE_SOURCE_ID_HERE_BY_SPREADING_THIS_AND_ADDING_SOURCE_ID',
  label: 'In specie?',
  type: ActionType.radioGroup,
  horizontal: true,
  horizontalOptionWidthXs: 6,
  initialValue: false,
  fullWidth: true,
  options: [
    {label: 'In specie', value: true},
    {label: 'Cash', value: false},
  ],
};

export const isDataGatherField: SelectField = {
  id: 'isDataGather',
  label: 'Data gather plan?',
  type: ActionType.select,
  options: [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'No',
      value: 'no',
    },
  ],
  initialValue: '',
};

export const isAuthorityHeldField: SelectField = {
  id: 'isAuthorityHeld',
  label: 'Authority held?',
  type: ActionType.select,
  options: [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'No',
      value: 'no',
    },
  ],
  initialValue: '',
};

export const transferShellPlanValueField: FormField = {
  id: `transfer.shell.planValue`,
  label: 'Current plan value',
  initialValue: '',
  currency: true,
  placeholder: '0',
  type: ActionType.text,
  decimals: 2,
};
export const transferShellAmountField: FormField = {
  id: `transfer.shell.singleClientAmount`,
  label: 'Transfer amount',
  initialValue: '',
  currency: true,
  placeholder: '0',
  type: ActionType.text,
  decimals: 2,
};

export const transferShellAccountNumberField: FormField = {
  id: `transfer.shell.accountNumber`,
  label: 'Policy Number',
  initialValue: '',
  type: ActionType.text,
};

export const transferShellPlanContactIdField: SelectAutocompleteField = {
  id: 'contactId',
  label: 'Plan contact',
  type: ActionType.selectAutocomplete,
  options: [],
  initialValue: '',
};
